import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'

// Get the root element
const container = document.getElementById('root')
if (!container) throw new Error('Root element not found')

// Simple app initialization
const root = createRoot(container)

root.render(
  <StrictMode>
    <App />
  </StrictMode>
)
